(() => {
  const DRAWER_SELECTOR = 'header-drawer';

  function setItemIndices(drawerRoot) {
    drawerRoot.querySelectorAll('.menu-drawer__menu').forEach((list) => {
      Array.from(list.children).forEach((item, index) => {
        if (!(item instanceof HTMLElement)) return;
        item.style.setProperty('--menu-item-index', index);
      });
    });
  }

  function markActiveTrail(drawerRoot) {
    drawerRoot.querySelectorAll('.menu-drawer__menu-item[aria-current="page"]').forEach((item) => {
      const parentDetails = item.closest('details');
      if (parentDetails) {
        const trigger = parentDetails.querySelector(':scope > summary.menu-drawer__menu-item');
        trigger?.classList.add('menu-drawer__menu-item--active');
      }
    });
  }

  function bindDrawer(drawer) {
    if (!(drawer instanceof HTMLElement) || drawer.dataset.modernNavReady === 'true') return;

    const rootDetails = drawer.querySelector(':scope > details');
    const panel = drawer.querySelector('#menu-drawer');

    if (!rootDetails || !panel) return;

    drawer.dataset.modernNavReady = 'true';
    setItemIndices(drawer);
    markActiveTrail(drawer);

    rootDetails.addEventListener('toggle', () => {
      const isOpen = rootDetails.hasAttribute('open');
      drawer.classList.toggle('is-open', isOpen);
      panel.toggleAttribute('data-mounted', isOpen);

      if (!isOpen) {
        drawer.querySelectorAll('.menu-drawer__menu-item--active').forEach((item) => {
          if (!item.hasAttribute('aria-current')) {
            item.classList.remove('menu-drawer__menu-item--active');
          }
        });
        drawer.querySelectorAll('.menu-drawer__accordion-toggle[aria-expanded="true"]').forEach((toggle) => {
          const panel = document.getElementById(toggle.getAttribute('aria-controls'));
          toggle.setAttribute('aria-expanded', 'false');
          panel?.classList.remove('is-open');
          if (panel) panel.hidden = true;
        });
        markActiveTrail(drawer);
      }
    });

    drawer.querySelectorAll('.menu-drawer__accordion-toggle').forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const panelId = toggle.getAttribute('aria-controls');
        const panel = panelId ? document.getElementById(panelId) : null;
        if (!panel) return;

        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!isExpanded));
        toggle.classList.toggle('menu-drawer__menu-item--active', !isExpanded);
        panel.hidden = isExpanded;
        panel.classList.toggle('is-open', !isExpanded);
      });
    });
  }

  function init(root = document) {
    if (root instanceof HTMLElement && root.matches(DRAWER_SELECTOR)) {
      bindDrawer(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll(DRAWER_SELECTOR).forEach(bindDrawer);
    }
  }

  init();

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
        init(node);
      });
    });
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
